import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'Features/App/store';

/**
 * ОПЦИОНАЛЬНО (Управление сайдбаром либо через slice либо через state в нужном компоненте)
 */
type SidebarInitialState = {
  isHide: boolean
  isPinned: boolean
}

export const SIDEBAR_SLICE = 'sidebar';

const initialState: SidebarInitialState = {
  isHide: false,
  isPinned: true,
};

const sidebarSlice = createSlice({
  name: SIDEBAR_SLICE,
  initialState,
  reducers: {
    setIsHide: (state, { payload }: PayloadAction<SidebarInitialState['isHide']>) => {
      state.isHide = payload;
    },
    setIsPinned: (state, { payload }: PayloadAction<SidebarInitialState['isPinned']>) => {
      state.isPinned = payload;
    },
  },
});

export default sidebarSlice.reducer;

export const {
  setIsHide,
  setIsPinned,
} = sidebarSlice.actions;

export const isHideSelector = (state: AppState) => state.sidebar.isHide;
export const isPinnedSelector = (state: AppState) => state.sidebar.isPinned;
